/**
 * Accepts a base string and an optional object with parameters and creates a string to send to Sentry. E2E tests also rely on this format.
 *
 * analyticsId('hello-world', { name: 'John' }) turns into the following: hello-world name:John
 */
export const analyticsId = (base, params) => {
    if (!params) {
        return base;
    }
    return Object.keys(params).reduce((previous, key) => {
        if (typeof params[key] === 'undefined' || params[key] === null || params[key] === '') {
            return `${previous} ${key}:NULL`;
        }
        return `${previous} ${key}:${params[key]}`;
    }, base);
};
/**
 *
 * Helper function that just uses createAnalyticsId and returns an object with data-analytics-id. Useful for e.g. React components.
 *
 * <Button onClick={...} {...analyticsProps('hello-world', { name: 'John' })} />
 */
export const analyticsProps = (base, params) => {
    return {
        'data-analytics-id': analyticsId(base, params)
    };
};
